module.exports = __webpack_public_path__ + "img/upgrade-empty-img.12563437.png";